import { useEffect } from 'react';
import { isRouteErrorResponse, useLocation, useRouteError } from 'react-router-dom';
import { api, getAuthToken } from '../lib/api';

const safeValue = (value: string) => value.replace(/[^a-zA-Z0-9._:-]/g, '_').slice(0, 160) || 'unknown';

export function WebRouteErrorPage() {
  const error = useRouteError();
  const location = useLocation();
  const errorName = error instanceof Error ? error.name : isRouteErrorResponse(error) ? `RouteError${error.status}` : 'UnknownError';

  useEffect(() => {
    if (!getAuthToken()) return;
    void api('/system/client-events', {
      method: 'POST',
      body: JSON.stringify({
        event: 'web_crash',
        platform: 'web',
        release: 'web-1',
        errorName: safeValue(errorName).slice(0, 80),
        fingerprint: safeValue(`${errorName}:${location.pathname.split('/').filter(Boolean)[0] ?? 'root'}`),
        context: location.pathname.startsWith('/admin') ? 'unknown' : location.pathname.startsWith('/sofor') ? 'assignments' : 'unknown',
      }),
    }).catch(() => undefined);
  }, [errorName, location.pathname]);

  return <main className="grid min-h-screen place-items-center bg-mist px-5 text-center">
    <section className="w-full max-w-lg rounded-3xl border border-slate-200 bg-white p-8 shadow-xl">
      <p className="text-sm font-bold uppercase tracking-[0.18em] text-coral">EHES Lojistik</p>
      <h1 className="mt-3 text-3xl font-black text-navy">Beklenmeyen bir hata oluştu</h1>
      <p className="mt-3 text-slate-600">Hata güvenli biçimde kaydedildi. Sayfayı yenileyebilir veya ana sayfaya dönebilirsiniz.</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <button type="button" onClick={() => window.location.reload()} className="rounded-xl bg-coral px-5 py-3 font-bold text-white">Sayfayı yenile</button>
        <a href="/" className="rounded-xl border border-slate-300 px-5 py-3 font-bold text-navy">Ana sayfa</a>
      </div>
    </section>
  </main>;
}
